module.exports = __webpack_public_path__ + "img/floor_f5_02.69a2f94b.png";